import * as React from 'react'
import { BulkActionButton } from '../BulkActionButton'

type Props = {
  recordCount: number
  onButtonClick: () => void
  hasPermission: boolean
}

export function BulkActionAddNoteButton(props: Props) {
  const { hasPermission, onButtonClick, recordCount } = props

  return (
    <>
      <BulkActionButton
        onClick={onButtonClick}
        type="addNote"
        helperText=""
        hasPermission={hasPermission}
        errorString="You do not have permission to perform bulk Add notes."
        dataTestId="addNote"
      >
        {recordCount > 1 ? 'Add Note' : 'Add/View Note'}
      </BulkActionButton>
    </>
  )
}
